import type { useGetUserRoles } from '@festina-life/authentication'
import { notEmpty } from '@festina-life/core'

import type { useAnnotations } from './useAnnotations'

export const getAnnotationData = <TData>(
  annotations: readonly { component: string; data: TData[] }[],
  component: string,
): TData[] =>
  annotations.find((annotation) => annotation.component === component)?.data ??
  []

export const getAnnotationGroups = (
  annotations: ReturnType<typeof useAnnotations>,
): string[] =>
  Array.from(
    new Set(
      Object.values(annotations)
        .flatMap((annotation) => annotation ?? [])
        .filter(notEmpty),
    ),
  )

export const isAllowedToViewEntity = ({
  annotations,
  tenantId,
  userRoles,
}: {
  annotations: ReturnType<typeof useAnnotations>
  tenantId: string | undefined
  userRoles: ReturnType<typeof useGetUserRoles>['data']
}) =>
  getAnnotationGroups(annotations).every((group) =>
    userRoles?.legalEntity?.has(`${tenantId}.${group}.T`),
  )
